module.exports = __webpack_public_path__ + "img/cg.b3aaa3b9.svg";